import ProductPreviewImageBeforeUpload from './ProductPreviewImageBeforeUpload'

export default ProductPreviewImageBeforeUpload
